class WebhookNotification {

    constructor() {
        this.name = '';
        this.description = '';
        this.uuid = '';
        this.categories = [];
        this.severities = [];
        this.url = '';
        this.secret = '';
        this.template = '';
    }

    static getSearchKey() {
        return 'name';
    }

    static fromRaw(raw) {
        let notification = new WebhookNotification();
        notification.name = raw.name;
        notification.description = raw.description;
        notification.uuid = raw.uuid;
        notification.categories = raw.categories;
        notification.severities = raw.severities;
        notification.url = raw.postUrl;
        notification.secretSet = raw.secretSet;
        notification.template = raw.template;
        return notification;
    }

    toRaw() {
        let notification = {};
        notification.name = this.name;
        notification.description = this.description;
        notification.categories = this.categories;
        notification.severities = this.severities;
        notification.postUrl = this.url;
        notification.secret = this.secret;
        notification.template = this.template;
        notification.uuid = this.uuid;
        return notification;
    }
}

module.exports = WebhookNotification;


// WEBPACK FOOTER //
// ./src/azurebackup/model/WebhookNotification.js